import isUrl from "is-url-superb";

/**
 * Decode base64URL string to original data
 */
export function base64URLdecode(str) {
    const base64Encoded = str.replace(/-/g, "+").replace(/_/g, "/");
    const padding =
        str.length % 4 === 0 ? "" : "=".repeat(4 - (str.length % 4));
    const base64WithPadding = base64Encoded + padding;
    return atob(base64WithPadding)
        .split("")
        .map((char) => String.fromCharCode(char.charCodeAt(0)))
        .join("");
}

export function extractUrlFromText(text) {
    if (typeof text === "string") {
        const urlMatch = text.split(" ").filter((el) => isUrl(el));
        return urlMatch;
    }
    return null;
}
